module.exports = __webpack_public_path__ + "static/img/14085A_3_R_20200729_fit.df3326c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14085A_3_R_20200729_fit.png
// module id = E0QD
// module chunks = 0